import React, { PropsWithChildren, useState } from 'react'
import { createContext } from 'lib/createContext'
import { CompumaticPunch } from 'api/admin/timeClock/listCompumaticPunches'

type EditCompumaticPunchWorkflow = {
  open: (punch: CompumaticPunch) => void
  close: () => void
  isOpen: boolean
  punch: CompumaticPunch | null
}

type CompumaticClockPunchesWorkflowsContextState = {
  editPunchFlow: EditCompumaticPunchWorkflow
}

const [Context, useCompumaticClockPunchesWorkflowsContextValue] =
  createContext<CompumaticClockPunchesWorkflowsContextState>({
    name: 'CompumaticClockPunchesWorkflowsContext',
  })

export const CompumaticClockPunchesWorkflowsProvider = ({
  children,
}: PropsWithChildren) => {
  const [isEditPunchFlowOpen, setIsEditPunchFlowOpen] = useState(false)
  const [editPunch, setEditPunch] = useState<CompumaticPunch | null>(null)

  const value: CompumaticClockPunchesWorkflowsContextState = {
    editPunchFlow: {
      open: (punch: CompumaticPunch) => {
        setEditPunch(punch)
        setIsEditPunchFlowOpen(true)
      },
      close: () => setIsEditPunchFlowOpen(false),
      isOpen: isEditPunchFlowOpen,
      punch: editPunch,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useCompumaticClockPunchesWorkflowsContextValue }
